module.exports = __webpack_public_path__ + "img/LVL-icon.a8ac9bab.svg";